export default __webpack_public_path__ + "static/media/AR-4.bf04e4ba.jpg";